import React from "react";
import logo from "../img/img-ui/CECILogoOval.webp";

const Logo = ({ size }) => {
  return <img src={logo} alt="CECI School logo" width={size} />;
};

export default Logo;
